import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TDropdownOption {
  id: string;
  name: string;
}

export interface IDropdownOption extends TDropdownOption {}

const DropdownOption = Model(
  (model: TDropdownOption): IDropdownOption => {
    const _dropdownOption: TDropdownOption = Object.assign({}, model);

    let create = (dropdownOption: IDropdownOption): IDropdownOption => {
      let obj = ValidatableObject(dropdownOption);
      return obj;
    };

    let dropdownOption = {
      get id() {
        return _dropdownOption.id;
      },
      set id(values) {
        _dropdownOption.id = values;
      },
      get name() {
        return _dropdownOption.name;
      },
      set name(values) {
        _dropdownOption.name = values;
      }
    };

    return create(dropdownOption);
  }
);

export default DropdownOption;
